import { render, staticRenderFns } from "./exhibition.vue?vue&type=template&id=3b7a78b5&scoped=true"
import script from "./exhibition.vue?vue&type=script&lang=js"
export * from "./exhibition.vue?vue&type=script&lang=js"
import style0 from "./exhibition.vue?vue&type=style&index=0&id=3b7a78b5&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b7a78b5",
  null
  
)

export default component.exports